<template lang="pug">
  .chat-exchanges__main(v-loading="isLoading" v-if="getActiveChat.id")
    .chats__title Статистика
    .chat-exchanges__container
      .chat-exchanges-count__container Всего заявок: {{ exchangesCount }}
      .chat-exchange__container(v-for="exchange in getActiveChat.exchanges")
        .chat-exchange__block
          .chat-exchange__value # {{ exchange.id }}
          .chat-exchange__value {{ exchange.created }}
          .chat-exchange__value(
            :class="{ finished: exchange.status === 'finished', canceled: exchange.status === 'canceled'}"
            ) {{ statuses[exchange.status] || exchange.status }}
          i.chat-exchange-copy__icon.el-icon-copy-document(@click="copyExchangeInfo(exchange)")
        .chat-exchange__block
          .chat-exchange__value(v-if="exchange.deal_id") # {{ exchange.deal_id }}
        .chat-exchange__block
          .chat-exchange__value
            span {{ `${paymentSystems[exchange.payment_system] || exchange.payment_system} (${exchange.handler})` }}
            span(v-if="exchange.bank") {{ ` (${exchange.bank})` }}
          .chat-exchange__value {{ exchange.fiat_amount }} р.
        .chat-exchange__block
          .chat-exchange__value {{ exchange.requisites }}
          .chat-exchange__value {{ exchange.crypto_amount_source }}
        .chat-exchange__block(v-if="exchange.status !== 'finished'")
          .exchange-claim__container(v-if="exchange.claim && activeClaimStatuses[exchange.claim.status]")
            .exchange-claim-status
              .exchange-claim__info
                .exchange-claim-info__block Статус претензии: {{ claimsLocales[exchange.claim.status] || exchange.claim.status }}
                .exchange-claim-info__block Сумма претензии: {{ `${exchange.claim.fiat_amount} р.` }}
                .exchange-claim-info__block(v-if="exchange.claim.id") ID претензии: {{ `${exchange.claim.id}` }}
                .exchange-claim-info__block.error(v-if="exchange.claim.status === 'error'") Ошибка: {{ `${exchange.claim.error}` }}
              el-button(v-if="exchange.claim.status !== 'reject'" @click="startCancelClaim(exchange)" size="mini") Отменить
          .exchange-problem__container
            el-button(v-if="exchange.isProblemOrder" size="mini" type="success" @click="changeProblemStatus(exchange.id, false)") Проблема решена
            el-button(v-else size="mini" type="warning" @click="changeProblemStatus(exchange.id, true)") Пометить как проблемную
          el-button(v-if="!exchange.claim || !activeClaimStatuses[exchange.claim.status] || exchange.claim.status === 'reject'" size="mini" @click="enableOrderEdit(exchange, 'claim')") Претензия
          el-button(size="mini" @click="enableOrderEdit(exchange, 'finish')") Завершить
    .chat-exchanges__container.tickets__container
      .chat-exchanges-count__container Всего диалогов: {{ ticketsCount }}
      .chat-tickets__container
        .chat-ticket__container(v-for="ticket in formattedTickets" :class="{ active: ticket.isCurrentTicket }")
          span Заявка {{ ticket.order_id }}
          .ticket-status__container
            .ticket-status
              span.color-danger(v-if="ticket.closed") Закрыт
              span.color-success(v-else) Открыт
            .ticket-icons
              i.el-icon-warning.color-warning(v-if="ticket.isCurrentOrder" title="Текущая заявка")
              i.el-icon-d-arrow-right.order__btn(
                v-if="!ticket.isCurrentTicket"
                title="Перейти к диалогу"
                @click="$emit('loadChat', { id: ticket.id, isOpened: ticket.closed })"
              )
        hr
    el-dialog(:visible.sync="isFinishDialogVisible" :title="orderEditTitle" width="30%" :before-close="resetFinishExchange")
      .h3 Введите сумму
      .exchange-finish__container
        .exchange-finish__input
          el-input(v-model="finishExchange.fiat_amount")
        .checks__container(v-if="finishExchange.mode === 'claim' && false")
          .title Чеки
          .exist-checks__container
            .upload__title Ссылки на чеки
              .urls__container
                .url__container(v-for="(url, index) in finishExchange.urls")
                  .url-text {{ url }}
                  el-button(type="danger" size="mini" @click="deleteClaimUrl(index)") Удалить
              .urls__container
                el-input(v-model="addingClaimUrl")
                el-button.url-add__btn(type="primary" size="mini" @click="addClaimUrl()") Добавить
          .exist-checks__container
            .upload__title Изображения из чата
            .exist-checks__block
              .exist-check__img(
                v-for="chatImage in chatImages"
                :class="selectedClaimImages.includes(chatImage) ? 'active' : 'inactive'"
                )
                .check__btn(
                  @click="handleClaimChatImage(chatImage)"
                  :class="selectedClaimImages.includes(chatImage) ? 'el-icon-check' : 'el-icon-close'"
                  )
                a(:href="chatImage.replace('prev_', '')" target="_blank")
                  img(:src="chatImage")
          .upload__container
            .upload__title Загрузить новые
            input(ref="claimInput" @change="addClaimImages()" type="file" multiple)
        .checks__container(v-if="finishExchange.mode === 'claim'")
          .title Ссылка на чек
          el-input(v-model="finishExchange.attachment_link")
        .finish-reason(v-if="finishExchange.mode === 'finish'")
          .finish-reason-param
            .title Причина завершения
            el-select(v-model="finishExchange.finish_reason")
              el-option(
                v-for="(reason, value) in finishReasons"
                v-if="reason.availableOption"
                :value="value"
                :label="reason.description"
                :key="`finish_reason_${value}`"
              )
          .finish-reason-param(v-if="finishExchange.finish_reason === 'compensation' || finishExchange.finish_reason === 'duplicate'")
            .title ID связной заявки
            el-input(v-model="finishExchange.compensation_order_id" placeholder="Введите ID связной заявки")
        .exchange-finish__buttons
          el-button(type="success" @click="finishOrder()") Подтвердить
          el-button(type="danger" @click="resetFinishExchange()") Отменить
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import { LOAD_CHAT } from "../../store/const/chats";
  import { CANCEL_CLAIM, EDIT_ORDER, FINISH_ORDER, OPEN_CLAIM } from "../../store/const/orders";
  import instruments from "../../mixins/instruments";
  export default {
    name: 'ChatsExchanges',
    mixins: [
      instruments,
    ],
    props: {
      showChatLoadingStatus: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isFinishDialogVisible: false,
        finishExchange: {
          mode: '',
          id: null,
          exchange: null,
          fiat_amount: null,
          status: '',
          images: [],
          urls: [],
          finish_reason: '',
          compensation_order_id: null,
          attachment_link: ''
        },
        selectedClaimImages: [],
        addingClaimUrl: '',
        finishExchangeAmount: null,
        claimsLocales: {
          opened: 'Открыта',
          success: 'Успешна',
          new: 'Добавлена',
          error: 'Ошибка',
          reject: 'Отклонена',
          canceled: 'Отменена',
        },
        activeClaimStatuses: {
          opened: true,
          new: true,
          reject: true,
          error: true,
        },
        isFileReady: false,
        chatImages: []
      }
    },
    watch: {
      getActiveChat() {
        this.updateChatImagesThumbs();
      },
    },
    computed: {
      ...mapGetters('chats', {
        getActiveChat: 'activeChat',
      }),
      ...mapGetters('settings', [
        'statuses',
        'paymentSystems'
      ]),
      ...mapGetters('orders', [
        'finishReasons',
      ]),
      ...mapGetters([
        'loading',
      ]),
      ...mapGetters('user', {
        'getUserRole': 'getRole'
      }),
      isLoading() {
        return this.loading(LOAD_CHAT) === 'loading' && this.showChatLoadingStatus;
      },
      messageMember() {
        return this.getActiveChat.member;
      },
      exchangesCount() {
        return this.getActiveChat.exchanges.length;
      },
      ticketsCount() {
        return this.getActiveChat.tickets.length;
      },
      orderEditTitle() {
        return this.finishExchange.mode === 'finish'
          ? `Завершение заявки №${this.finishExchange.id}`
          : `Претензия по заявке №${this.finishExchange.id}`;
      },
      isCanViewClaims() {
        return this.getUserRole === 'superadmin' || this.getUserRole === 'support';
      },
      isCanFinishOrders() {
        return this.getUserRole === 'superadmin' || this.getUserRole === 'support';
      },
      formattedTickets() {
        return this.getActiveChat.tickets.map((ticket) => {
          return {
            ...ticket,
            isCurrentTicket: this.getActiveChat.id === ticket.id,
            isCurrentOrder: this.getActiveChat.order_id === ticket.order_id,
          }
        })
      }
    },
    methods: {
      ...mapActions('chats', {
        loadChat: LOAD_CHAT,
      }),
      ...mapActions('orders', {
        editOrder: EDIT_ORDER,
        finishOrderById: FINISH_ORDER,
        openClaim: OPEN_CLAIM,
        cancelClaim: CANCEL_CLAIM,
      }),
      enableOrderEdit(order, mode) {
        this.finishExchangeAmount = order.fiat_amount;
        this.finishExchange = {
          mode,
          id: order.id,
          exchange: order.exchange,
          fiat_amount: order.fiat_amount,
          status: order.status,
          images: [],
          urls: [],
          attachment_link: '',
        };
        this.isFinishDialogVisible = true;
      },
      async finishOrder() {
        try {
          const { id, exchange, fiat_amount, images, urls, attachment_link } = this.finishExchange;
          const confirmMessage = this.finishExchange.mode === 'finish'
            ? 'Вы уверены, что ходите завершить заявку?'
            : 'Вы уверены, что хотите открыть претензию по заявке?';
          this.$confirm(confirmMessage, 'Внимание', {
            confirmButtonText: 'Подтвердить',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }).then(async () => {
            let requestParams = {
              id,
              data: {},
            };
            let request;
            if (this.finishExchange.mode === 'finish') {
              if (!this.finishExchange.finish_reason) {
                return this.$message.warning('Укажите причину завершения заявки');
              }
              if (this.finishExchange.finish_reason === 'compensation' || this.finishExchange.finish_reason === 'duplicate') {
                if (!this.finishExchange.compensation_order_id) {
                  return this.$message.warning('Укажите ID связной заявки');
                }
                requestParams.data.compensation_order_id = this.finishExchange.compensation_order_id;
              }
              requestParams.data.reason = this.finishExchange.finish_reason;
              if (fiat_amount !== this.finishExchangeAmount) {
                requestParams.data.fiat_amount = fiat_amount;
              }
              request = await this.finishOrderById(requestParams);
            } else {
              if (attachment_link && !this.isValidURL(attachment_link)) {
                return this.$message.warning('Адрес чека не валидный');
              }
              requestParams.data = {
                fiat_amount,
                images,
                urls,
                chat_id: this.getActiveChat.id,
                attachment_link,
              };
              if (this.selectedClaimImages.length > 0) {
                requestParams.data.savedImages = this.selectedClaimImages.map((url) => {
                  const staticPos = url.indexOf('/static/');
                  return url.slice(staticPos  + 8).replace('prev_', '');
                });
              }
              request = await this.openClaim(requestParams);
            }
            if (request.success) {
              const successMessage = this.finishExchange.mode === 'finish'
                ? `Заявка ${id} успешно закрыта`
                : `Претензия по заявке №${id} успешно открыта`;
              this.$message({
                type: 'success',
                message: successMessage,
              });
            } else {
              const errorMessage = this.finishExchange.mode === 'finish'
                ? `Не удалось закрыть заявку: ${request.message}`
                : `Не удалось открыть претензию по заявке: ${request.message}`;
              this.$message({
                type: 'error',
                message: errorMessage,
              });
            }
            this.resetFinishExchange();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.finishExchange.mode === 'finish' ? 'Завершение отменено' : 'Открытие претензии отменено'
            });
          });
        } catch (e) {
          const errorMessage = this.finishExchange.mode === 'finish'
            ? `Не удалось закрыть заявку`
            : `Не удалось открыть претензию по заявке`;
          this.$message({
            type: 'error',
            message: errorMessage,
          });
        }
      },
      resetFinishExchange() {
        this.isFinishDialogVisible = false;
        this.finishExchange = {
          id: null,
          exchange: null,
          fiat_amount: null,
          mode: '',
          status: '',
          images: [],
          urls: [],
          attachment_link: '',
        };
        this.selectedClaimImages = [];
        this.addingClaimUrl = '';
        this.finishExchangeAmount = null;
      },
      startCancelClaim(exchange) {
        this.$confirm('Вы уверены, что хотите отменить претензию?', 'Внимание', {
          confirmButtonText: 'Подтвердить',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(async () => {
          const request = await this.cancelClaim({ id: exchange.id });
          if (request.success) {
            this.$message({
              type: 'success',
              message: 'Претензия успешно отменена',
            });
          } else {
            this.$message({
              type: 'error',
              message: `Не удалось отменить претензию: ${request.message}`,
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Отмена претензии отменена'
          });
        });
      },
      async changeProblemStatus(id, isProblemOrder) {
        const confirmMessage = isProblemOrder
          ? 'Вы уверены, что хотите отметить заявку как проблемную?'
          : 'Пометить проблему как решённую?';
        this.$confirm(confirmMessage, 'Внимание', {
          confirmButtonText: 'Подтвердить',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(async () => {
          const request = await this.editOrder({
            id: id,
            data: {
              isProblemOrder,
            },
          });
          if (request.success) {
            this.$message({
              type: 'success',
              message: isProblemOrder
                ? 'Заявка помечена проблемной'
                : 'Проблема помечена решённой',
            });
          } else {
            this.$message({
              type: 'error',
              message: isProblemOrder
                ? `Не удалось пометить заявку как проблемную: ${request.message}`
                : `Не удалось пометить проблему как решённую: ${request.message}`,
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Отменено'
          });
        });
      },
      addClaimImages() {
        const current = this.$refs.claimInput;
        this.finishExchange.images = [];
        const files = current.files;
        let isError = false;

        const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        const filePromises = Object.entries(files).map((item) => {
          return new Promise((resolve, reject) => {
            const [index, file] = item;
            if (allowedFileTypes.includes(file.type)) {
              const reader = new FileReader();
              reader.readAsBinaryString(file);

              reader.onload = (event) => {
                this.finishExchange.images.push(`data:${file.type};base64,${btoa(
                  event.target.result
                )}`);

                resolve();
              };
              reader.onerror = function () {
                console.log("can't read the file");
                reject();
              };
            } else {
              this.$message.error('Для загрузки разрешены только изображения в формате JPG/JPEG/PNG/GIF');
              isError = true;
            }
          });
        });

        if (isError) {
          current.value = '';
        } else {
          Promise.all(filePromises)
            .then()
            .catch((error) => {
              this.$message.error('Ошибка загрузки файлов');
              console.log(error);
            });
        }
      },
      updateChatImagesThumbs() {
        const imagesElements = document.querySelectorAll('.chat-photo img');
        const result = [];
        for (const imageElement of imagesElements) {
          const url = imageElement.getAttribute('src');
          result.push(url);
        }
        this.chatImages = result;
      },
      handleClaimChatImage(url) {
        if (this.selectedClaimImages.includes(url)) {
          this.selectedClaimImages.splice(this.selectedClaimImages.indexOf(url), 1);
        } else {
          this.selectedClaimImages.push(url);
        }
      },
      addClaimUrl() {
        this.finishExchange.urls.push(this.addingClaimUrl);
        this.addingClaimUrl = '';
      },
      deleteClaimUrl(index) {
        this.finishExchange.urls.splice(index, 1);
      },
      async copyExchangeInfo(exchange) {
        const dealIdRoles = ['superadmin', 'admin', 'support'];
        const deal_id =  dealIdRoles.includes(this.getUserRole)
          ? exchange.deal_id
            ? ` (${exchange.deal_id})`
            : ''
          : '';
        const info = `${exchange.id}${deal_id}\n${exchange.requisites}`;
        await this.copyTextToClipboard(info);
      },
      fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
        textArea.style.width = "0px";
        textArea.style.height = "0px";
        textArea.style.overflow = "hidden";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          if (successful) {
            return true;
          }
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      },
      copyTextToClipboard(text) {
        if (!navigator.clipboard) {
          return this.fallbackCopyTextToClipboard(text);
        }
        navigator.clipboard.writeText(text).then(function () {
          return true;
        }, function (err) {
          console.error('Async: Could not copy text: ', err);
        });
      },
      getClassListForTicket(ticket) {
        const result = {};
        if (ticket.id === this.getActiveChat.id) {
          result['current-ticket'] = true;
        }
        if (ticket.order_id === this.getActiveChat.order_id) {
          result['current-order'] = true;
        }
        return result;
      }
    }
  }
</script>
<style>
  .chat-exchanges__main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .chat-exchanges__container {
    overflow-y: scroll;
    max-width: 300px;
    font-size: 12px;
  }

  .chat-exchanges__container.tickets__container {
    margin-top: 5px;
    border-top: 1px solid #676767;
    min-height: 100px;
    max-height: 480px;
  }

  .chat-exchange__container {
    padding: 5px;
    border-bottom: 1px solid #8f8f8f;
  }

  .chat-exchange__block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .chat-exchange__value {
    padding: 2px 4px;
  }

  .chat-exchange__value.finished {
    color: green;
  }

  .chat-exchange__value.canceled {
    color: red;
  }

  .exchange-finish__input {
    margin: 10px auto;
  }

  .chat-exchange-copy__icon {
    cursor: pointer;
  }

  .chat-exchanges-count__container {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding: 5px;
    border-bottom: 1px dotted #676767;
    color: #2537b5;
  }

  .exchange-claim__container {
    width: 100%;
    margin: 5px auto;
    border: 1px solid #e2e2e2;
    padding: 2px;
  }

  .exchange-claim-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .exchange-claim-info__block {
    margin: 2px auto;
  }

  .exchange-problem__container {
    width: 100%;
    margin: 5px auto;
  }

  .exchange-claim-info__block.error {
    color: red;
  }

  .upload__container {
    margin-bottom: 10px;
  }

  .upload__title {
    margin-bottom: 5px;
  }

  .exist-checks__container {
    margin: 10px auto;
    border: 1px solid #bdbdbd;
    padding: 5px;
  }

  .exist-checks__block {
    display: flex;
    overflow-x: scroll;
  }

  .exist-check__img {
    position: relative;
    width: fit-content;
    padding: 8px;
    border: 1px solid #bdbdbd;
    margin: 2px 4px;
  }

  .exist-check__img.active {
    border: 1px solid #67c23a;
  }

  .check__btn {
    position: absolute;
    right: -1px;
    top: -1px;
    border: 1px solid #bdbdbd;
    cursor: copy;
    background-color: #878787;
    color: white;
  }

  .active .check__btn {
    border: 1px solid #54ff00;
    color: #67c23a;
  }

  .urls__container {
    margin-top: 10px;
  }

  .url__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2px auto;
    padding: 2px;
    border-bottom: 1px solid #e3e3e3;
  }

  .url-text {
    margin-right: 5px;
  }

  .url-add__btn {
    margin-top: 5px;
  }

  .chat-ticket__container {
    margin: 2px 0;
    padding: 2px;
  }

  .chat-ticket__container.active {
    border: 1px solid green;
  }

  .ticket-status__container {
    font-weight: bold;
    display: flex;
    justify-content: space-between;
  }

  .order__btn {
    font-weight: bold;
    cursor: pointer;
    margin-left: 2px;
  }

</style>
